import { render, staticRenderFns } from "./ListReportPromo.vue?vue&type=template&id=56098e38"
import script from "./ListReportPromo.vue?vue&type=script&lang=js"
export * from "./ListReportPromo.vue?vue&type=script&lang=js"
import style0 from "./ListReportPromo.vue?vue&type=style&index=0&id=56098e38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports